import * as React from 'react';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';

interface IUpdateDateProps {
  updateDate: string;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
  })
);

const UpdateDate: React.FC<IUpdateDateProps> = ({
  updateDate,
  expanded,
  handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange('expandedRevised')}
      key={'expandedRevised'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`expandedRevisednbh-content`}
        id={`expandedRevisedbh-header`}
      >
        <Typography className={classes.heading}>{t("process.revision_information")}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
        {updateDate && (
          <Typography dangerouslySetInnerHTML={{ __html: `${t("process.last_updated")}: ${updateDate}` }} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default UpdateDate;